import React from 'react'

import { Container, Typography, Box } from '@material-ui/core'

const NotFoundPage: React.FC = () => {
  return (
    <Container>
      <Typography variant="h1" component={Box} pb={6} pt={6}>
        NOT FOUND PAGE
      </Typography>
    </Container>
  )
}

export default NotFoundPage
